<template>
<div class="block-img" :class="{empty: !media}">
  <div class="img-empty" v-if="!media">
    (not selected)
  </div>
  <div class="img-selected" v-else>
    <a :href="media.urlFilename" target="_blank"><img :src="media.urlFilename" alt="" :class="{video: oembed}" /></a>
    <div>
      <label>Name:</label> <span>{{ media.filename }}</span><br />
      <template v-if="oembed">
      <label>Author:</label> <span>{{ oembed.author_name }}</span><br />
      <label>Provider:</label> <span>{{ oembed.provider_name }}</span><br />
      </template>
      <template v-if="media.width">
      <label>Dimensions:</label> <span>{{ media.width }}x{{ media.height }}</span><br />
      </template>
      <template v-if="media.size">
      <label>File size:</label> <span>{{ formatFileSize(media.size) }}</span><br />
      <label>File type:</label> <span>{{ formatFileType(media.filename) }}</span><br />
      </template>
      <button class="btn btn-large" v-on:click.prevent="$emit('update:modelValue', '')">Remove</button>
    </div>
  </div>
  <button class="btn btn-large" v-if="!media" v-on:click.prevent="select">Select</button>
</div>
</template>

<script>
import api from '@/Util/api';
export default {
  props: ["modelValue"],
  data: ()=>({
    media: null,
  }),
  watch: {
    modelValue: {
      immediate: true,
      async handler() {
        if (this.modelValue) {
          var data=await api.get("File", this.modelValue);
          this.media=data;
        } else
          this.media=null;
      },
    },
  },
  computed: {

    oembed() {
      try {
        return JSON.parse(this.media.oembed);
      } catch(e) {
        return null;
      }
    },
  },
  methods: {
    createLink(type) {
      return {
        name: "page",
        params: {
          path: [...this.$route.params.path, type],
        }
      }
    },
    select() {
      this.stores.callbacks.pushCallback((...args)=>this.doSelect(...args));
      this.$router.push(this.createLink('File'));
    },
    doSelect(item) {
      this.$emit("update:modelValue", item.uuid);
    },
    formatFileType(path) {
      console.log(path);
      var res=path && path.match(/\.([^.\/]+)$/);
      return res?res[1]:"unknown";
    },
    formatFileSize(size) {
      size*=1;
      if (!size)
        return "(unknown)";
      if (size<1024)
        return size+" B";
      size/=1024;
      if (size<1024)
        return size.toFixed(2)+" kB";
      size/=1024;
      if (size<1024)
        return size.toFixed(2)+" MB";
      size/=1024;
      return size.toFixed(2)+" GB";
    },
  },
}
</script>
